import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ScrollText, AlertTriangle } from 'lucide-react';
import { listPolicies, getPolicy } from '../api';

const Policy = () => {
  const { slug } = useParams();
  const [policy, setPolicy] = useState(undefined);
  const [tabs, setTabs] = useState([]);

  useEffect(() => {
    listPolicies().then((all) => setTabs(all.map((p) => ({ slug: p.slug, label: p.title })))).catch(() => {});
  }, []);
  useEffect(() => {
    setPolicy(undefined);
    getPolicy(slug).then(setPolicy).catch(() => setPolicy(null));
    window.scrollTo(0, 0);
  }, [slug]);

  if (policy === undefined) return <div className="pt-40 pb-40 text-center"><p className="font-cormorant text-2xl text-[#f5ecd9]/50">Loading…</p></div>;
  if (policy === null) return (
    <div className="pt-40 pb-40 text-center">
      <p className="font-cormorant text-3xl text-[#f5ecd9]/70">Policy not found.</p>
      <Link to="/" className="text-[#f0d582] underline mt-4 inline-block">Back Home</Link>
    </div>
  );

  return (
    <div className="pt-28 pb-24 min-h-screen" data-testid="policy-page">
      <div className="max-w-4xl mx-auto px-5">
        <div className="text-center mb-8">
          <ScrollText className="h-10 w-10 text-[#f0d582] mx-auto mb-4" />
          <h1 className="font-cinzel text-4xl md:text-5xl text-gold-gradient" data-testid="policy-title">{policy.title}</h1>
          <div className="gold-divider mt-5" />
        </div>

        <div className="flex flex-wrap justify-center gap-2 mb-10">
          {tabs.map((t) => (
            <Link key={t.slug} to={`/policy/${t.slug}`} data-testid={`policy-tab-${t.slug}`} className={`px-4 py-1.5 rounded-full text-[11px] uppercase tracking-widest font-jost transition-all duration-300 ${slug === t.slug ? 'bg-gradient-to-r from-[#d6197d] to-[#ff4da6] text-white' : 'border border-[#d4af37]/30 text-[#f5ecd9]/70 hover:border-[#ff4da6]/60 hover:text-[#f0d582]'}`}>{t.label}</Link>
          ))}
        </div>

        {policy.needs_owner_input && (
          <div className="flex items-start gap-3 rounded-xl border border-[#d4af37]/40 bg-[#d4af37]/5 p-4 mb-8" data-testid="policy-draft-notice">
            <AlertTriangle className="h-5 w-5 text-[#f0d582] flex-shrink-0 mt-0.5" />
            <p className="font-jost text-sm text-[#f5ecd9]/70"><span className="text-[#f0d582] font-medium">Draft — owner confirmation required.</span> This policy contains placeholder guidance. Specific terms must be confirmed by the business owner before going live.</p>
          </div>
        )}

        <div className="space-y-6">
          {policy.updated_at && <p className="font-jost text-xs text-[#f5ecd9]/50 tracking-widest uppercase">Last Updated: {String(policy.updated_at).slice(0, 10)}</p>}
          {policy.intro && <p className="font-cormorant text-lg text-[#f5ecd9]/75 leading-relaxed">{policy.intro}</p>}
          <div className="card-glass rounded-2xl p-7">
            <p className="font-jost text-[#f5ecd9]/75 leading-relaxed whitespace-pre-line">{policy.body}</p>
          </div>
        </div>

        <p className="text-center font-cormorant text-lg text-[#f5ecd9]/50 mt-12">Still have questions? <Link to="/contact" className="text-[#f0d582] hover:text-[#ff4da6] underline">Contact us</Link>.</p>
      </div>
    </div>
  );
};

export default Policy;
